/**
 * @Description: 仓库温湿度动态明细 - eCharts图表配置项设置
 * @Author: lufenggang
 * @LastEditors: lufenggang
 * @Date: 2019/8/07
 * @LastEditTime: 2019/8/12 15:25:00
 */
/**
 * 获取getBarLineOpt参数
 * @param data 数据
 * @param baseTemperature  基准温度
 * @param baseHumidity  基准湿度
 * @param obj  温度和湿度的最高最低值
 * @returns {*} Object
 */
// 条形折线图
const getBarLineOpt = (data, obj) => {
  let rData = data;
  let xCategories = [];
  let inTData1 = []; //内置温度
  let inHData1 = []; //内置湿度
  let inTData2 = [];
  let inHData2 = [];
  let inTData3 = [];
  let inHData3 = [];
  let inTData4 = [];
  let inHData4 = [];
  // let outTData = []; //外置温度
  // let outHData = []; //外置湿度
  let demandTHData = []; //温度要求(高)
  let demandTLData = []; //温度要求(低)
  let demandHHData = []; //湿度要求(高)
  let demandHLData = []; //湿度要求(低)
  // let datumTData = []; //基准温度
  // let datumHData = []; //基准湿度
  rData.forEach(node => {
    xCategories.push(node.gpsTime);
    if (node.hasOwnProperty("temperature")) {
      node.tem1 = node.temperature;
      node.hum1 = node.humidity;
    }
    ["tem1", "tem2", "tem3", "tem4"].forEach((key, idx) => {
      if (node[key] == -999) {
        eval(`inTData${idx + 1}`).push(null);
      } else {
        eval(`inTData${idx + 1}`).push(node[key]);
      }
    });
    ["hum1", "hum2", "hum3", "hum4"].forEach((key, idx) => {
      if (node[key] == -999) {
        eval(`inHData${idx + 1}`).push(null);
      } else {
        eval(`inHData${idx + 1}`).push(node[key]);
      }
    });
    // if (node.temperature == -999) {
    //   inTData.push(null);
    // } else {
    //   inTData.push(node.temperature);
    // }
    // if (node.humidity == -999) {
    //   inHData.push(null);
    // } else {
    //   inHData.push(node.humidity);
    // }
    // outHData.push(node.hum2);
    // outTData.push(node.tem2);
    demandTHData.push(obj.tempHigh);
    demandTLData.push(obj.tempLow);
    demandHHData.push(obj.humidityHigh);
    demandHLData.push(obj.humidityLow);
  });
  let legendList, colorList;
  if (data[0].hasOwnProperty("temperature")) {
    //判断是否为冷藏车温湿度明细
    legendList = [
      "温度",
      "湿度",
      // "外置温度",
      // "外置湿度",
      "温度要求",
      "湿度要求"
      // "基准温度",
      // "基准湿度"
    ];
    colorList = [
      "#56bb24",
      "#1889fd",
      "#89d066",
      "#5eadfe",
      "#abdd92",
      "#8cc4fe",
      "#56bb24",
      "#1889fd"
    ];
  } else {
    legendList = [
      "温度1",
      "湿度1",
      "温度2",
      "湿度2",
      "温度3",
      "湿度3",
      "温度4",
      "湿度4",
      // "外置温度",
      // "外置湿度",
      "温度要求",
      "湿度要求"
      // "基准温度",
      // "基准湿度"
    ];
    colorList = [
      "#5CB0EF",
      "#A4CA78",
      "#1375C0",
      "#5D970D",
      "#0000FF",
      "#339900",
      "#000066",
      "#336600",
      "#56bb24",
      "#1889fd"
    ];
  }
  //获取Legend数据
  const getLegendData = () => {
    let arr = [];
    legendList.forEach(item => {
      arr.push({
        name: item,
        textStyle: {
          fontSize: 12,
          fontWeight: "normal",
          fontStyle: "normal",
          color: "#909399"
        },
        icon: getSymnolState(item).icon
      });
    });
    return arr;
  };
  //获取series数据
  const getSeriesData = () => {
    let arr = [];
    legendList.forEach(item => {
      arr.push({
        name: item,
        type: "line",
        itemStyle: {
          normal: {
            lineStyle: {
              width: getSymnolState(item).lineWidth,
              type: getSymnolState(item).lineType
            }
          }
        },
        yAxisIndex: item.startsWith("湿度") ? 1 : 0,
        // symbol: getSymnolState(item).symnolType,
        smooth: true, //这句就是让曲线变平滑的
        data: initData(item)
      });
    });
    //单独处理温度要求
    arr.push(
      {
        name: "温度要求",
        type: "line",
        itemStyle: {
          normal: {
            lineStyle: {
              width: 2,
              type: "dashed" //'dotted'虚线 'solid'实线
            }
          }
        },
        yAxisIndex: 0,
        // symbol: "rect",
        // symbolSize: 5,
        data: demandTLData
      },
      {
        name: "湿度要求",
        type: "line",
        itemStyle: {
          normal: {
            lineStyle: {
              width: 2,
              type: "dashed" //'dotted'虚线 'solid'实线
            }
          }
        },
        yAxisIndex: 1,
        // symbol: "rect",
        // symbolSize: 5,
        data: demandHLData
      }
    );
    return arr;
  };
  //获取不同类型的状态
  const getSymnolState = item => {
    let obj = {};
    // if (
    //   item == "内置温度" ||
    //   item == "内置湿度" ||
    //   item == "外置温度" ||
    //   item == "外置湿度"
    // )
    if (item == "温度要求" || item == "湿度要求") {
      obj.lineType = "dashed";
      obj.lineWidth = "2";
      obj.symnolType = "roundRect";
      obj.icon = "line";
    } else {
      obj.lineType = "solid";
      obj.lineWidth = "2";
      obj.symnolType = "";
      obj.icon = "";
    }
    return obj;
  };
  //初始化不同类型的数据
  const initData = item => {
    let data = null;
    switch (item) {
      case "温度":
      case "温度1":
        data = inTData1;
        break;
      case "湿度":
      case "湿度1":
        data = inHData1;
        break;
      case "温度2":
        data = inTData2;
        break;
      case "湿度2":
        data = inHData2;
        break;
      case "温度3":
        data = inTData3;
        break;
      case "湿度3":
        data = inHData3;
        break;
      case "温度4":
        data = inTData4;
        break;
      case "湿度4":
        data = inHData4;
        break;
      case "温度要求":
        data = demandTHData;
        break;
      case "湿度要求":
        data = demandHHData;
        break;
      // case "基准温度":
      //   data = datumTData;
      //   break;
      // case "基准湿度":
      //   data = datumHData;
      //   break;
      default:
    }
    return data;
  };
  let objData = {
    title: {
      text: "",
      textStyle: {
        fontWeight: "normal",
        fontSize: 12
      },
      left: "60",
      top: "20"
    },
    animation: false,
    color: colorList,
    legend: {
      orient: "horizontal",
      x: "center",
      y: "93%",
      bottom: 20,
      padding: [5, 0],
      selected: {
        温度: true,
        湿度: true,
        温度1: true,
        湿度1: true,
        温度2: true,
        湿度2: true,
        温度3: true,
        湿度3: true,
        温度4: true,
        湿度4: true,
        // 外置温度: true,
        // 外置湿度: true,
        温度要求: false,
        湿度要求: false
        // 基准温度: false,
        // 基准湿度: false
      },
      data: getLegendData()
    },
    tooltip: {
      trigger: "axis",
      axisPointer: {
        lineStyle: {
          color: "#e6ebf2"
        }
      },
      formatter: function(data) {
        let proportion = "时间：" + data[0].name + "</br>";
        let inTData = ""; //内置温度
        let inHData = ""; //内置湿度
        // let outTData = ""; //外置温度
        // let outHData = ""; //外置湿度
        let demandTData = ""; //温度要求
        let demandHData = ""; //湿度要求
        // let datumTData = ""; //基准温度
        // let datumHData = ""; //基准湿度
        data.forEach(item => {
          //判断
          switch (item.seriesName) {
            case "温度":
            case "温度1":
            case "温度2":
            case "温度3":
            case "温度4":
              inTData +=
                item.seriesName +
                "：" +
                (item.value === "" ||
                item.value === null ||
                item.value === undefined
                  ? "--"
                  : item.value + "℃") +
                "</br>";
              break;
            case "湿度":
            case "湿度1":
            case "湿度2":
            case "湿度3":
            case "湿度4":
              inHData +=
                item.seriesName +
                "：" +
                (item.value === "" ||
                item.value === null ||
                item.value === undefined
                  ? "--"
                  : item.value + "%RH") +
                "</br>";
              break;
            // case "外置温度":
            //   outTData =
            //     item.seriesName +
            //     "：" +
            //     (item.value == "" ? item.value : item.value + "℃") +
            //     "</br>";
            //   break;
            // case "外置湿度":
            //   outHData =
            //     item.seriesName +
            //     "：" +
            //     (item.value == "" ? item.value : item.value + "%RH") +
            //     "</br>";
            //   break;
            case "温度要求":
              demandTData =
                item.seriesName +
                "：" +
                (obj.tempLow != "" && obj.tempHigh != ""
                  ? obj.tempLow + "℃~" + obj.tempHigh + "℃"
                  : "") +
                "</br>";
              break;
            case "湿度要求":
              demandHData =
                item.seriesName +
                "：" +
                (obj.humidityLow != "" && obj.humidityHigh != ""
                  ? obj.humidityLow + "%RH~" + obj.humidityHigh + "%RH"
                  : "") +
                "</br>";
              break;
            // case "基准温度":
            //   datumTData =
            //     item.seriesName +
            //     "：" +
            //     (item.value == "" ? item.value : item.value + "℃") +
            //     "</br>";
            //   break;
            // case "基准湿度":
            //   datumHData =
            //     item.seriesName +
            //     "：" +
            //     (item.value == "" ? item.value : item.value + "%RH") +
            //     "</br>";
            //   break;
            default:
          }
        });
        return (
          proportion +
          inTData +
          inHData +
          // outTData +
          // outHData +
          demandTData +
          demandHData
          // datumTData +
          // datumHData
        );
      }
    },
    grid: {
      left: "5%",
      right: "8%",
      bottom: "8%",
      containLabel: true
    },
    xAxis: {
      type: "category",
      boundaryGap: false,
      name: "",
      nameTextStyle: {
        color: "#606266"
      },
      nameGap: 25,
      axisLine: {
        lineStyle: {
          color: "#e6ebf2"
        }
      },
      nameLocation: "start",
      splitLine: {
        show: true,
        lineStyle: {
          color: ["#e6ebf2"],
          width: 1,
          type: "solid"
        }
      },
      axisLabel: {
        color: "#606266",
        padding: [0, 0, 0, 10]
      },
      data: xCategories
    },
    yAxis: [
      {
        name: "温度(℃)",
        nameTextStyle: {
          color: "#606266"
        },
        type: "value",
        axisLabel: {
          color: "#606266",
          formatter: "{value}"
        },
        axisLine: {
          lineStyle: {
            color: "#e6ebf2"
          }
        },
        splitLine: {
          show: true,
          lineStyle: {
            color: ["#e6ebf2"],
            width: 1,
            type: "solid"
          }
        },
        splitArea: {
          show: true,
          areaStyle: {
            color: ["#fafbfc", "#fff"]
          }
        }
      },
      {
        name: "湿度(%RH)",
        nameTextStyle: {
          color: "#606266"
        },
        type: "value",
        axisLabel: {
          color: "#606266",
          formatter: "{value}"
        },
        axisLine: {
          lineStyle: {
            color: "#e6ebf2"
          }
        },
        splitLine: {
          show: true,
          lineStyle: {
            color: ["#e6ebf2"],
            width: 1,
            type: "solid"
          }
        },
        splitArea: {
          show: true,
          areaStyle: {
            color: ["#fafbfc", "#fff"]
          }
        }
      }
    ],
    series: getSeriesData()
  };
  return objData;
};

export { getBarLineOpt };
